/** @format */

import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Col, Label, Row } from "reactstrap";
import { useSelector } from "react-redux";

export default function SelectCategory({ title, onFormChange, value }) {
  const { categories } = useSelector((state) => state.products);
  const [selectData, setSelectData] = useState([]);

  useEffect(() => {
    const updatedSelectData = (categories || []).map((cat) => ({
      label: cat.name,
      value: {
        id: cat.term_id,
        name: cat.name,
      },
    }));
    setSelectData(updatedSelectData);
  }, [categories]);

  const handleChange = (selected) => {
    if (selected) {
      onFormChange("categories", [selected.value]); // Always send as array
    } else {
      onFormChange("categories", []); // Empty array if nothing selected
    }
  };

  // Expecting value to be an array (even for single item)
  const formattedValue =
    value && value.length > 0
      ? {
          label: value[0]?.name,
          value: value[0],
        }
      : null;

  return (
    <Row className="g-2 product-tag">
      <Col xs={12}>
        <Label className="d-block">{title}</Label>
      </Col>
      <Col xs={12} className="m-0">
        <Select
          value={formattedValue}
          onChange={handleChange}
          options={selectData}
          className="basic-single-select"
          classNamePrefix="select"
          isClearable
          placeholder="Select a category..."
        />
      </Col>
    </Row>
  );
}
